export default "__VITE_ASSET__Dgu$ixZU__"